import { configureStore } from '@reduxjs/toolkit';
import addressReducer from './addressSlice';
import userReducer from './userSlice';
import networkReducer from './networkSlice';

export default configureStore({
    reducer: {
        address: addressReducer,
        userData: userReducer,
        network: networkReducer,
    },
})
